import Geocode from "react-geocode";
import { toast } from "react-toastify";
export const GetLatLngWithAddress = (address: string) => {
  return Geocode.fromAddress(address).then(
    (response: any) => {
      return response.results[0].geometry.location;
    },
    (error: any) => {
      return toast.error("You entered wrong zip code");
    }
  );
};
